import get from 'lodash/get';
import isFunc from 'lodash/isFunction';
import isUndefined from 'lodash/isUndefined';

type ValuesMapType = {
  [componentPropValue: string]: string | Function,
};

export const styledProp = (prop: string, valuesMap: ValuesMapType) => {
  const getter = map => componentProps => {
    const value = get(map, componentProps[prop]) || map.default;
    return isFunc(value) ? value(componentProps) : value;
  };

  return isUndefined(valuesMap) ? getter : getter(valuesMap);
};
